import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NavParams, ToastController} from 'ionic-angular';

import { Rodeo } from '../../../../model/rodeo';

import { Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs/operators';
import { ReportsService } from '../../../../services/reports.service';
import { TurnoutReportData } from '../../../../model/turnout-report.model';
import { TurnoutReason } from '../../../../model/registration-change-request';
import { DateHelperService } from '../../../../services/date-helper';

@Component({
	selector: 'page-turnout-list-report',
	templateUrl: 'report-turnout-list.html'
	
})
export class TurnoutListReport implements OnInit, OnDestroy {
    @Input('rodeo') rodeo: Rodeo;
    @Input('options') options: FormGroup;
    @Output('loading') loading = new EventEmitter<boolean>(false);
    newTurnoutReport: TurnoutReportData;
    
    private isLoading = false;
    private subscriptions: Subscription[] = [];

    constructor(
        private navParams: NavParams,
        private reportService: ReportsService,
        private toast: ToastController,
        public dateHelper: DateHelperService
    ) { }

    async ngOnInit() {
        if (!this.rodeo)
            this.rodeo = this.navParams.get('rodeo');

        this.subscriptions.push(
            this.options.valueChanges
            .pipe(
                distinctUntilChanged()
            ).subscribe(async (e) => await this.updateFromFormValues(e))
        );

        await this.updateFromFormValues(this.options.value);
    }

    ngOnDestroy() {
        this.subscriptions.forEach(x => x.unsubscribe());
    }

    getTurnoutReasonDisplay(reason: TurnoutReason) {
        switch (reason) {
            case TurnoutReason.DoctorRelease:
                return 'Doc Release';
            case TurnoutReason.VetRelease:
                return 'Vet Release';
            case TurnoutReason.NonNotifiedTurnout:
                return 'Non NTO';
            case TurnoutReason.VisibleInjury:
                return 'Visible Injury'
            case TurnoutReason.Drawout:
                return 'Drawout';
            case TurnoutReason.Turnout:
            case TurnoutReason.NotifiedTurnout:
                return 'NTO';
        }
    }

    getPerfTotals(perfName: string) {
        if (!this.newTurnoutReport) {
            return;
        }

        return this.newTurnoutReport.totals.byPerformance.find(x => x.performanceName == perfName);
    }

    private async updateFromFormValues(filters) {
        if (this.isLoading) return;
        
        this.isLoading = true;
        setTimeout(() => {
            this.loading.emit(true);
        }, 100);

        try {
            this.newTurnoutReport = await this.reportService.getTurnoutReport(filters);
        } catch (err) {
            console.error(err);
            this.toast.create({
                message: 'Could not generate report',
                duration: 2500
            }).present();
        } finally {
            this.isLoading = false;
            setTimeout(() => {
                this.loading.emit(false);
            }, 100);
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-turnout-list.ts